/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.CostRequestResponseDto>>;
export function request(params: API.tms.costRequest.page.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/costRequest/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
